<div class="page-title">
  <div class="title" [class.white]="showBackButton">
    @if (!currentPet) {
      <h3>{{ 'pet-details.page-title' | translate }}</h3>
    }
    @if (currentPet) {
      <h3>{{ 'pet-details.page-title-pet-name' | translate: { petName: currentPet.pet_name } }}</h3>
    }
  </div>
</div>

<div class="page-body">
  @if (showBackButton) {
    <div class="inner-navigation">
      <div class="back" (click)="navigateBack()">
        <p class="text-button-small">{{ 'pet-details.back-button-text' | translate }}</p>
      </div>
    </div>
  }

  <div class="form" [formGroup]="petInfoForm" #petInfoFormElement>
    @if (!currentPet) {
      <div class="row form-field">
        <div class="title">
          <p class="subtitle-14">{{ 'pet-details.selected-pets' | translate }}</p>
        </div>
        <div class="input">
          <div class="selected-pets">
            @for (pet of selectedPets; track pet) {
              <div class="pet">
                <p>{{ pet.pet_name }}</p>
              </div>
            }
          </div>
          @if (showAddPet()) {
            <div class="add-pet" (click)="addPet()">
              <mat-icon>add</mat-icon>
              <p>{{ 'pet-details.add-pet' | translate }}</p>
            </div>
          }
          @if (!showAddPet()) {
            <div class="add-pet" (click)="addPet()">
              <mat-icon>cached</mat-icon>
              <p>{{ 'pet-details.change-selection' | translate }}</p>
            </div>
          }
        </div>
      </div>
      <div class="row form-field">
        <div class="title">
          <p class="subtitle-14">{{ 'pet-details.vet-invoice' | translate }}</p>
        </div>
        <div class="input vet-invoice-input">
          <ul>
            <li>{{ 'pet-details.vet-invoice-format-requirement-header' | translate }}</li>
            <ul>
              <li>{{ 'pet-details.vet-invoice-format-requirement1' | translate }}</li>
              <li>{{ 'pet-details.vet-invoice-format-requirement2' | translate }}</li>
              <li>{{ 'pet-details.vet-invoice-format-requirement3' | translate }}</li>
              <li>{{ 'pet-details.vet-invoice-format-requirement4' | translate }}</li>
            </ul>
            <li>{{ 'pet-details.vet-invoice-info-requirement-header' | translate }}</li>
          </ul>
          <img class="example-invoice" [src]="exampleInvoiceImageSrc" alt="">
          <calingo-fnol-drag-n-drop
            [singleFileAllowed]="true"
            [maxFileSizeBytes]="maxUploadSizeBytes"
            #vetInvoice
            (onFileChange)="onFileListChange()">
          </calingo-fnol-drag-n-drop>
          @if (vetInvoice.fileList.length > 0 && showFileSizeError) {
            <mat-error>
              {{ 'pet-details.file-size-error' | translate }}
            </mat-error>
          }
          @if (vetInvoice.fileList.length > 0 && showFileTypeError) {
            <mat-error
              >{{ 'pet-details.file-type-error' | translate }}
            </mat-error>
          }
        </div>
      </div>
    }

    <!--NEW PAGE-->
    @if (currentPet) {
      <div class="row form-field">
        <div class="title">
          <p class="subtitle-14">{{ 'pet-details.diagnoses' | translate }}</p>
        </div>
        <div class="input">
          <calingo-fnol-autocomplete></calingo-fnol-autocomplete>
        </div>
      </div>
      <div class="row form-field" [class.hidden]="!showFieldsForOnlyNotPreventions()">
        <div class="title">
          <p class="subtitle-14">{{ 'pet-details.is-it-follow-up-treatment' | translate }}</p>
        </div>
        <div class="inline-select">
          <label for="yes" [class.selected]="petInfoForm.get('isItFollowUp')?.value === true">
            <input id="yes" type="radio" [value]="true" formControlName="isItFollowUp">
            <span>{{ 'pet-details.yes' | translate }}</span>
          </label>
          <label for="no" [class.selected]="petInfoForm.get('isItFollowUp')?.value === false">
            <input id="no" type="radio" [value]="false" formControlName="isItFollowUp">
            <span>{{ 'pet-details.no' | translate }}</span>
          </label>
        </div>
      </div>
      <div class="row form-field" [class.hidden]="petInfoForm.get('isItFollowUp')?.value === false">
        <div class="title">
          <p class="subtitle-14">{{ 'pet-details.precedent-claim-title' | translate }}</p>
        </div>
        <div class="inline-select">
          <mat-select class="input" formControlName="precedentClaimId" [placeholder]="'pet-details.precedent-claim-placeholder' | translate">
            @for (claim of precedentClaimsList; track claim) {
              <mat-option
                [value]="claim">{{ claim.claim_date | date: 'dd.MM.yyyy' }} - {{ claim.cause }}
              </mat-option>
            }
            <mat-option value="no-selected">{{ 'pet-details.precedent-claim-no-selected' | translate }}</mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row form-field" [class.hidden]="!showFieldsManualInput() || !showDiagnosisAdditionalInformation()">
        <div class="title">
          <p class="subtitle-14">{{ 'pet-details.diagnosis-additional-info' | translate }}</p>
        </div>
        <div class="input">
          <textarea class="input" type="text" formControlName="diagnosisAdditionalInformation"></textarea>
        </div>
      </div>
      <div class="row form-field" [class.hidden]="!showFieldsManualInput() || !showAccidentDateField()">
        <div class="title">
          <p class="subtitle-14">{{ 'pet-details.accident-date-field-info' | translate }}</p>
        </div>
        <div class="input">
          <div class="form-field-date">
            <input matInput
              class="input"
              [matDatepicker]="accidentDateField"
              (click)="accidentDateField.open()"
              [max]="maxDate"
              formControlName="accidentDateField">
            <mat-datepicker-toggle matSuffix [for]="accidentDateField"></mat-datepicker-toggle>
            <mat-datepicker #accidentDateField></mat-datepicker>
          </div>
        </div>
      </div>
      <div class="row form-field"
        [class.hidden]="!showFieldsManualInput() || !showFieldsForNotOnlyPreventionsOrAccident() || onlyAccidentDiagnosisSelected()">
        <div class="title">
          <p class="subtitle-14">{{ 'pet-details.condition-noted' | translate }}</p>
        </div>
        <div class="input">
          <div class="form-field-date">
            <input matInput
              class="input"
              [matDatepicker]="dateConditionNoticed"
              (click)="dateConditionNoticed.open()"
              [max]="maxDate"
              formControlName="dateConditionNoticed">
            <mat-datepicker-toggle matSuffix [for]="dateConditionNoticed"></mat-datepicker-toggle>
            <mat-datepicker #dateConditionNoticed></mat-datepicker>
          </div>
        </div>
      </div>
      <div class="row form-field" [class.hidden]="!showFieldsManualInput() || !showFieldsForNotOnlyPreventionsOrAccident()">
        <div class="title">
          <p
          class="subtitle-14">{{ 'pet-details.condition-previously-treated' | translate:{ name: petInfoForm.get('petName')?.value || ('pet-details.your-pet' | translate) } }}</p>
        </div>
        <div class="inline-select">
          <label for="treatedYes" [class.selected]="petInfoForm.get('conditionPreviouslyTreated')?.value === true">
            <input id="treatedYes" type="radio" [value]="true" formControlName="conditionPreviouslyTreated">
            <span>{{ 'pet-details.yes' | translate }}</span>
          </label>
          <label for="treatedNo" [class.selected]="petInfoForm.get('conditionPreviouslyTreated')?.value === false">
            <input id="treatedNo" type="radio" [value]="false" formControlName="conditionPreviouslyTreated">
            <span>{{ 'pet-details.no' | translate }}</span>
          </label>
        </div>
      </div>
      @if (petInfoForm.get('conditionPreviouslyTreated')?.value) {
        <div class="row form-field"
          [class.hidden]="!showFieldsManualInput() || !showFieldsForNotOnlyPreventionsOrAccident()"
          >
          <div class="title">
            <p
            class="subtitle-14">{{ 'pet-details.condition-first-treated' | translate:{ name: petInfoForm.get('petName')?.value || ('pet-details.your-pet' | translate) } }}</p>
          </div>
          <div class="input">
            <div class="form-field-date">
              <input matInput
                class="input"
                [matDatepicker]="dateConditionFirstTreated"
                (click)="dateConditionFirstTreated.open()"
                [max]="maxDate"
                formControlName="dateConditionFirstTreated">
              <mat-datepicker-toggle matSuffix [for]="dateConditionFirstTreated"></mat-datepicker-toggle>
              <mat-datepicker #dateConditionFirstTreated></mat-datepicker>
            </div>
          </div>
        </div>
      }
      <div class="row form-field" [class.hidden]="onlyPreventionOrIllnessDiagnosisSelected()">
        <div class="title">
          <p class="subtitle-14">{{ 'pet-details.third-party-fault' | translate }}</p>
        </div>
        <div class="inline-select">
          <label for="thirdPartyFaultYes" [class.selected]="petInfoForm.get('thirdPartyFault')?.value === true">
            <input id="thirdPartyFaultYes" type="radio" [value]="true" formControlName="thirdPartyFault">
            <span>{{ 'pet-details.yes' | translate }}</span>
          </label>
          <label for="thirdPartyFaultNo" [class.selected]="petInfoForm.get('thirdPartyFault')?.value === false">
            <input id="thirdPartyFaultNo" type="radio" [value]="false" formControlName="thirdPartyFault">
            <span>{{ 'pet-details.no' | translate }}</span>
          </label>
        </div>
      </div>
      <div class="row form-field">
        <div class="title">
          <p class="subtitle-14">{{ 'pet-details.additional-info' | translate }}</p>
        </div>
        <div class="input">
          <textarea type="text" class="input" formControlName="additionalInformation"></textarea>
        </div>
      </div>
    }

    @if (!isLastPet()) {
      <div class="row form-field">
        <button class="button primary" [disabled]="isButtonDisabled()" (click)="next()">
          {{ 'pet-details.next-page-button' | translate }}
        </button>
      </div>
    }

    @if (isLastPet()) {
      <div class="row form-field">
        <button class="button primary" [disabled]="isButtonDisabled()" (click)="next()">
          {{ 'pet-details.submit-vet-visit-button' | translate }}
        </button>
      </div>
    }
  </div>
</div>
